(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1404],{

/***/ 68867:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/popular/videos",
      function () {
        return __webpack_require__(939);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ TruncatedTagsList; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Tag/Tag.tsx
var Tag = __webpack_require__(90202);
// EXTERNAL MODULE: ../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js
var classnames = __webpack_require__(83849);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./utils/useWindowSize/useWindowSize.tsx
var useWindowSize = __webpack_require__(16485);
;// CONCATENATED MODULE: ./modules/Tags/TruncatedTagsList/hooks.ts


function useTruncatedList(ref) {
    const { width  } = (0,useWindowSize/* useWindowSize */.i)();
    const [hiddenElements, setHiddenElements] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        if (!ref.current) return;
        const listElements = getListElements(ref.current);
        const listWidth = ref.current.offsetWidth;
        const elements = hideElementsThatNotFit(listElements, listWidth);
        setHiddenElements(elements.hiddenElements);
    }, [
        width
    ]);
    function getListElements(list) {
        return Array.from(list.querySelectorAll("li"));
    }
    function hideElementsThatNotFit(elements, containerWidth) {
        return elements.reduce((acc, el)=>{
            const nextTagsWidth = acc.tagsWidth + el.offsetWidth;
            let nextHiddenElements = acc.hiddenElements;
            if (nextTagsWidth + 120 > containerWidth) {
                el.style.position = "absolute";
                el.style.opacity = "0";
                nextHiddenElements++;
            } else {
                el.removeAttribute("style");
            }
            return {
                tagsWidth: nextTagsWidth,
                hiddenElements: nextHiddenElements
            };
        }, {
            tagsWidth: 0,
            hiddenElements: 0
        });
    }
    return {
        hiddenElements
    };
}

;// CONCATENATED MODULE: ./modules/Tags/TruncatedTagsList/TruncatedTagsList.tsx





const TruncatedTagsList = (param)=>{
    let { tags , color ="gray" , prefixTag , suffixTag , className  } = param;
    const listRef = (0,react.useRef)(null);
    const { hiddenElements  } = useTruncatedList(listRef);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        ref: listRef,
        className: classnames_default()("max-w-full w-full flex gap-1 overflow-hidden", className),
        children: [
            prefixTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline-block",
                children: prefixTag
            }),
            tags.map((tag)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    style: {
                        position: "absolute",
                        opacity: 0
                    },
                    className: "inline-block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                        value: tag.name,
                        size: "sm",
                        color: color
                    })
                }, tag.id)),
            suffixTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: "inline-block",
                children: suffixTag
            }),
            hiddenElements > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag/* Tag */.V, {
                id: "list-counter",
                value: "+ ".concat(hiddenElements, " more"),
                color: "gray"
            })
        ]
    });
};


/***/ }),

/***/ 939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ videos; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./modules/Video/VideoModalContext.tsx
var VideoModalContext = __webpack_require__(35715);
// EXTERNAL MODULE: ./modules/Video/VideoModal/VideoModal.tsx + 4 modules
var VideoModal = __webpack_require__(67882);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/OutsidePageWrapper.tsx
var OutsidePageWrapper = __webpack_require__(55368);
// EXTERNAL MODULE: ./modules/PopularVideos/TvLabel/TvLabel.tsx
var TvLabel = __webpack_require__(13646);
// EXTERNAL MODULE: ./modules/PopularVideos/TvCover/TvCover.tsx
var TvCover = __webpack_require__(3332);
// EXTERNAL MODULE: ./modules/PopularVideos/TvContent/TvContent.tsx
var TvContent = __webpack_require__(59387);
// EXTERNAL MODULE: ./modules/Video/StreamModal/StreamModal.tsx + 4 modules
var StreamModal = __webpack_require__(41112);
// EXTERNAL MODULE: ./modules/PopularVideos/PopularVideoSection/StreamContext.tsx + 2 modules
var StreamContext = __webpack_require__(93715);
// EXTERNAL MODULE: ./utils/useAnalytics.tsx
var useAnalytics = __webpack_require__(24900);
;// CONCATENATED MODULE: ./modules/PopularVideos/TvFrame/TvFrameFullPage.tsx








const TvFrameFullPage = ()=>{
    const { onLiveNowStart  } = (0,useAnalytics/* useAnalytics */.z)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const open = (0,react.useCallback)(()=>{
        setIsOpen(true);
        onLiveNowStart();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StreamContext/* StreamProvider */.G, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "relative bg-neutral-200 w-full h-[568px] rounded-2xl overflow-hidden lg:h-[635px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TvCover/* TvCover */.z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-4 pt-8 pb-10 w-full h-full relative bg-transparent flex flex-col justify-between md:px-[30px] md:py-10 lg:px-[116px] lg:pt-[80px] lg:pb-[100px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TvLabel/* TvLabel */.h, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TvContent/* TvContent */.Q, {
                                onClick: open
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamModal/* StreamModal */.I, {
                isOpen: isOpen,
                setIsOpen: setIsOpen
            })
        ]
    });
};

// EXTERNAL MODULE: ../ui/src/components/Wrappers/InsidePageWrapper.tsx
var InsidePageWrapper = __webpack_require__(70996);
// EXTERNAL MODULE: ../ui/src/components/Typography/Typography.tsx
var Typography = __webpack_require__(59785);
// EXTERNAL MODULE: ../ui/src/components/Loading/Loading.tsx
var Loading = __webpack_require__(69193);
// EXTERNAL MODULE: ../ui/src/components/Pagination/Pagination.tsx
var Pagination = __webpack_require__(4015);
// EXTERNAL MODULE: ../ui/src/components/ItemsList/ItemsList.tsx
var ItemsList = __webpack_require__(14927);
// EXTERNAL MODULE: ./modules/Video/VideoCard/VideoCardWithTags.tsx
var VideoCardWithTags = __webpack_require__(95157);
;// CONCATENATED MODULE: ./modules/PopularVideos/PopularVideoList/PopularVideoList.tsx




const PopularVideoList = (param)=>{
    let { data  } = param;
    const { setSelectedVideo  } = (0,VideoModalContext/* useVideoModalContext */.sw)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemsList/* ItemsList */.o, {
        className: "w-full py-6 grid gap-4 md:gap-6 md:grid-cols-2 xl:grid-cols-3",
        items: data,
        noItemsMessage: "Videos not found",
        renderItem: (video)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(VideoCardWithTags/* VideoCardWithTags */.X, {
                thumbnailClassName: "h-[190px]",
                data: video,
                onClick: setSelectedVideo
            })
    });
};

// EXTERNAL MODULE: ./modules/Pages/PopularVideosPage/hooks.tsx
var hooks = __webpack_require__(26110);
// EXTERNAL MODULE: ./utils/InitialPaginationContext.tsx
var InitialPaginationContext = __webpack_require__(69933);
// EXTERNAL MODULE: ./utils/useScrollTo/useScrollTo.tsx
var useScrollTo = __webpack_require__(77795);
// EXTERNAL MODULE: ./utils/usePagination/usePaginationQuery.ts + 1 modules
var usePaginationQuery = __webpack_require__(61934);
;// CONCATENATED MODULE: ./modules/PopularVideos/PopularVideoList/PopularVideos.tsx






const PopularVideos = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsidePageWrapper/* InsidePageWrapper */.n, {
        className: "!mt-12 mb-[56px] md:!mt-[66px] lg:!mt-[112px]",
        id: "popular-videos",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                component: "h2",
                variant: "h3",
                className: "text-neutral-900 mb-6 lg:mb-10",
                children: "Popular videos"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularVideoListWithPagination, {})
        ]
    });
};
const PopularVideoListWithPagination = ()=>{
    const { initialPagination  } = (0,InitialPaginationContext/* useInitialPagination */.f)();
    const { scrollTo  } = (0,useScrollTo/* useScrollTo */.q)({
        id: "popular-videos"
    });
    const { usePopularVideosQuery  } = (0,hooks/* usePopularVideos */.l)();
    const { data: videos , isLoading , pagination  } = (0,usePaginationQuery/* usePaginationQuery */.Z)((paginationParams)=>usePopularVideosQuery(paginationParams), {
        initialPagination
    });
    if (isLoading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* Loading */.g, {});
    if (!videos) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularVideoList, {
                data: videos.data
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
                    pagination: pagination,
                    onPageChange: scrollTo
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./utils/useButtonsAnalytics.tsx
var useButtonsAnalytics = __webpack_require__(76356);
;// CONCATENATED MODULE: ./modules/Pages/PopularVideosPage/PopularVideosPage.tsx






const PopularVideosPage = (param)=>{
    let { initialPagination  } = param;
    (0,useButtonsAnalytics/* useButtonsAnalytics */.V)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModalContext/* VideoModalProvider */.ke, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TvFrameFullPage, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(InitialPaginationContext/* InitialPaginationContext.Provider */.y.Provider, {
                    value: {
                        initialPagination
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularVideos, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModalContext/* VideoModalConsumer */.xR, {
                    children: (param)=>/*#__PURE__*/ {
                        let { selectedVideo , setSelectedVideo  } = param;
                        return (0,jsx_runtime.jsx)(VideoModal/* VideoModal */.K, {
                            isOpen: !!selectedVideo,
                            setIsOpen: ()=>setSelectedVideo(null)
                        });
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/popular/videos.ts

var __N_SSP = true;
/* harmony default export */ var videos = (PopularVideosPage);


/***/ }),

/***/ 69933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useInitialPagination; },
/* harmony export */   "y": function() { return /* binding */ InitialPaginationContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const InitialPaginationContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
const useInitialPagination = ()=>{
    const ctx = react__WEBPACK_IMPORTED_MODULE_0__.useContext(InitialPaginationContext);
    if (!ctx) throw new Error("Initial pagination context is empty");
    return ctx;
};


/***/ }),

/***/ 16485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ useWindowSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

function useWindowSize() {
    const [windowSize, setWindowSize] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0
    });
    const handleSize = ()=>{
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        window.addEventListener("resize", handleSize);
        handleSize();
        return ()=>window.removeEventListener("resize", handleSize);
    }, []);
    return windowSize;
}


/***/ }),

/***/ 69193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _parkschannel_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59785);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);




const Loading = (param)=>{
    let { className , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full text-center my-5 flex justify-center items-center", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_parkschannel_ui__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
            component: "span",
            variant: "bodyLarge",
            className: "text-neutral-800 ",
            children: children || "Loading..."
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6774,9531,2411,4713,965,2485,9774,2888,179], function() { return __webpack_exec__(68867); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);